export const enum LeadEmailFormContactInputFieldNameEnum {
  name = 'name',
  email = 'email',
  phone = 'phone',
  countryCode = 'countryCode',
  enquiryType = 'enquiryType',
}
